import { get } from 'lodash';
import { useMemo } from 'react';
import { useAppContext } from '@/context';
import { fillableString } from '@/utils/string';
import { useSetFormValue } from '@/utils';
import { FormDeepKeys } from '@/types';

export const useEditFocusHandler = () => {
  const { dispatch, state } = useAppContext();
  const form = useMemo(() => ({ ...state.risk.data }), [state.risk.data]);
  const backendResponse = useMemo(() => ({ ...state.risk.backendResponse }), [state.risk.backendResponse]);
  const setFormValue = useSetFormValue(dispatch);

  const handleFocus = (event: CustomEvent) => {
    const target = event.target as HTMLInputElement;
    const inputValue = get(form, target.name);
    const initialValue = get(backendResponse, target.name);

    if (fillableString(inputValue) === fillableString(initialValue)) setFormValue(target.name as FormDeepKeys, '');
  };

  const handleBlur = (event: CustomEvent) => {
    const target = event.target as HTMLInputElement;
    const inputValue = get(form, target.name);
    const initialValue = get(backendResponse, target.name);

    if (Boolean(initialValue) && inputValue === '') setFormValue(target.name as FormDeepKeys, initialValue);
  };

  return { handleFocus, handleBlur };
};
